export default __webpack_public_path__ + "static/media/full-screen.a8ff51bf.svg";